import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { PartsContext } from './PartsContext';

const ItemsComponent = () => {
  const { partId } = useParams();
  const navigate = useNavigate();
  const imgRef = useRef(null);

  const [items, setItems] = useState([]);
  const [isSchemaDisplayed, setIsSchemaDisplayed] = useState(false);
  const { parts, currentItemIndex, setCurrentItemIndex, currentPartName, setCurrentPartName } = useContext(PartsContext);

  const redirectToShop = (event, partNumber) => {
    event.stopPropagation();
    const modifiedPartNumber = partNumber.substring(2).replace(/\s+/g, '');
    const url = `https://agrofrankopol-sklep.pl/?s=${modifiedPartNumber}`;
    window.open(url, '_blank');
  };

  const createPDF = () => {
    const input = imgRef.current;
    html2canvas(input).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const A4_WIDTH = 210;
      const A4_HEIGHT = 297;
      const MARGIN = 5;

      let imgWidth = A4_WIDTH - 2 * MARGIN;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (imgHeight > A4_HEIGHT - 2 * MARGIN) {
        imgHeight = A4_HEIGHT - 2 * MARGIN;
        imgWidth = (canvas.width * imgHeight) / canvas.height;
      }

      const doc = new jsPDF('p', 'mm');
      doc.addImage(imgData, 'PNG', MARGIN, MARGIN, imgWidth, imgHeight);

      const schemaImageURL = `http://161.97.115.122:5000/images/schematy/${(items.find(item => item.partId === partId) || {}).scheme}.jpg`;
      const logoURL = "http://161.97.115.122:5000/images/logo.png";

      doc.addPage();
      doc.addImage(schemaImageURL, 'PNG', MARGIN, MARGIN, imgWidth, imgHeight);

      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.addImage(logoURL, 'PNG', MARGIN, A4_HEIGHT - MARGIN - 25, 40, 25);
      }

      const pdfBlob = doc.output('blob');
      const url = window.URL.createObjectURL(pdfBlob);
      window.open(url, '_blank');
    });
  };

  useEffect(() => {
    async function fetchItems() {
      try {
        const response = await axios.get(`http://161.97.115.122:5000/items/${partId}`);
        setItems(response.data);

        if (response.data.length > 0 && response.data[0].scheme) {
          setIsSchemaDisplayed(true);
        }
      } catch (error) {
        console.error("Błąd podczas pobierania przedmiotów:", error);
      }
    }
    fetchItems();
  }, [partId]);

  useEffect(() => {
    const currentPart = parts.find(part => part._id === partId);
    if (currentPart) {
      setCurrentPartName(currentPart.nazwa);
      const currentIndex = parts.findIndex(part => part._id === partId);
      setCurrentItemIndex(currentIndex);
    }
  }, [partId, parts, setCurrentPartName, setCurrentItemIndex]);

  const goToNextItem = () => {
    if (currentItemIndex < parts.length - 1) {
      const nextIndex = currentItemIndex + 1;
      setCurrentItemIndex(nextIndex);
      navigate(`/items/${parts[nextIndex]._id}`);
    }
  };

  const goToPreviousItem = () => {
    if (currentItemIndex > 0) {
      const previousIndex = currentItemIndex - 1;
      setCurrentItemIndex(previousIndex);
      navigate(`/items/${parts[previousIndex]._id}`);
    }
  };

  const goBackToParts = () => {
    navigate(-1);
  };

  return (
    <div className="app-container">
      <div className="sidebar">
        <img className="logo" src="https://agrofrankopol-sklep.pl/wp-content/uploads/2022/05/logo-1024x635.png" alt="Logo" />
        <div className="menu">
          <ul>
            <li><a href="http://161.97.115.122:3000/">Strona Główna</a></li>
            <li><a href="https://agrofrankopol-sklep.pl/">Sklep internetowy</a></li>
            <li><a href="https://agrofrankopol-sklep.pl/kontakt/">Kontakt</a></li>
          </ul>
        </div>
      </div>
      <div className="content">
        <button onClick={createPDF} className="pdfbtn">Stwórz schemat (PDF)</button>

        <div className="main-content">
          <div className="scheme-container">
            {isSchemaDisplayed ? (
              <div>
                <img
                  ref={imgRef}
                  src={`http://161.97.115.122:5000/images/schematy/${(items.find(item => item.partId === partId) || {}).scheme}.jpg`}
                  alt="Schemat"
                  className="schemeIMG"
                  style={{ width: '1166px', height: '763px', zIndex: 1 }}
                />
              </div>
            ) : null}
          </div>
          <div className="catalog">
            <h1>{currentPartName}</h1>
            <button onClick={goToPreviousItem} className="back-button">Poprzedni</button>
            <button onClick={goToNextItem} className="back-button">Następny</button>
            <h4>Lista pasujących przedmiotów:</h4>
            <table className="clean-table">
              <thead>
                <tr>
                  <th className="nrsch">Nr.
                    <h6 className="tsch">(Na schemacie)</h6></th>
                  <th>Nr. Części</th>
                  <th>Opis</th>
                  <th>Oznaczenie</th>
                  <th>Sklep</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={item._id}>
                    <td>{item.itemNumber || 'N/A'}</td>
                    <td>{item.partNumber}</td>
                    <td>{item.description}</td>
                    <td>{item.remark || 'N/A'}</td>
                    <td>
                      <button className="cart-button" onClick={(event) => redirectToShop(event, item.partNumber)}>Zamów</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        
        </div>
      </div>
    </div>
  );
};

export default ItemsComponent;
